import {
  BASE_API_URL,
  DEFAULT_TIMEOUT,
} from '@modules/core/services/api/constants';
import { promiseTimeout } from '@utils/promises';

export interface EnvConfigJsonData {
  domains: {
    serve: string;
  };
  vars: {
    serve: {
      apiUrl: string | undefined;
    };
  };
  env: {
    isTesting: boolean;
    name: string;
  };
}

export const envLocalConfig: EnvConfigJsonData = {
  domains: {
    serve: '',
  },
  vars: {
    serve: {
      apiUrl: undefined,
    },
  },
  env: {
    isTesting: true,
    name: 'local',
  },
};

let fetchedURL: string | undefined;
let envConfig: EnvConfigJsonData | undefined;
let isTestingEnvVar = import.meta.env.DEV;

export function isLocalEnv(): boolean {
  return window.location.host.includes('localhost');
}

export function getApiUrl(): string {
  return fetchedURL ?? `${window.location.origin}${BASE_API_URL}`;
}

export function isTestingEnv(): boolean {
  return isTestingEnvVar;
}

export async function getEnvConfig(): Promise<EnvConfigJsonData> {
  return envConfig ?? fetchApiUrl();
}

export async function fetchApiUrl(): Promise<EnvConfigJsonData> {
  let result: EnvConfigJsonData;
  if (isLocalEnv()) {
    result = envLocalConfig;
  } else {
    const response = await promiseTimeout({
      promise: fetch(`${window.location.origin}/home/config/config.json`),
      timeout: DEFAULT_TIMEOUT,
      error: () => new Error('Failed to fetch config'),
    });
    result = await response.json() as EnvConfigJsonData;
  }

  envConfig = result;
  fetchedURL = result.vars.serve.apiUrl;
  isTestingEnvVar = result.env?.isTesting ?? false;
  return result;
}
